import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { CheckCircle2, AlertCircle } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const processed = useRef(false);
  const [estado, setEstado] = useState('verificando'); // verificando | ok | error
  const [mensaje, setMensaje] = useState('');

  useEffect(() => {
    if (processed.current || !token) { if (!token) { setEstado('error'); setMensaje('Enlace inválido: falta el token.'); } return; }
    processed.current = true;
    (async () => {
      try {
        const r = await axios.post(`${API_URL}/api/auth/verify-email`, { token });
        setMensaje(r.data.message);
        setEstado('ok');
      } catch (err) {
        setMensaje(err.response?.data?.detail || 'El enlace no es válido o ha caducado');
        setEstado('error');
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: '#030303' }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/manklar-logo-white.png" alt="Manklar" className="h-14 mx-auto" />
        </div>
        <div className="p-8 rounded-2xl text-center space-y-4" style={{ backgroundColor: 'rgba(10,10,10,0.8)', border: '1px solid rgba(255,255,255,0.08)' }} data-testid="verify-email-card">
          {estado === 'verificando' && (
            <>
              <div className="w-10 h-10 border-2 border-white/20 border-t-white rounded-full animate-spin mx-auto" />
              <p className="text-sm text-zinc-400">Verificando tu correo electrónico...</p>
            </>
          )}
          {estado === 'ok' && (
            <>
              <CheckCircle2 className="w-12 h-12 text-emerald-400 mx-auto" />
              <h2 className="text-xl font-light text-white font-['Outfit']">Correo verificado</h2>
              <p className="text-sm text-zinc-400" data-testid="verify-email-mensaje">{mensaje}</p>
              <Link to="/login">
                <Button className="w-full h-11 mt-2 bg-white text-black hover:bg-zinc-200 rounded-xl" data-testid="verify-ir-login-btn">Ir a iniciar sesión</Button>
              </Link>
            </>
          )}
          {estado === 'error' && (
            <>
              <AlertCircle className="w-12 h-12 text-red-400 mx-auto" />
              <h2 className="text-xl font-light text-white font-['Outfit']">No se pudo verificar</h2>
              <p className="text-sm text-zinc-400" data-testid="verify-email-mensaje">{mensaje}</p>
              <p className="text-xs text-zinc-600">Puedes solicitar un nuevo enlace desde tu perfil o contactando con Manklar.</p>
              <Link to="/login">
                <Button variant="outline" className="w-full h-11 mt-2 border-white/20 text-zinc-300 rounded-xl">Volver al inicio de sesión</Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
